import { render, staticRenderFns } from "./RailDocumentsDropdown.vue?vue&type=template&id=a0a636a0"
import script from "./RailDocumentsDropdown.js?vue&type=script&lang=js&external"
export * from "./RailDocumentsDropdown.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports